// Vendors
import React from 'react';

// Components
import { ApplicationCard } from '../AdminDashboard/components/AllApplications/components';

const AllApprovedApplications = ({
  applications,
  selectedApplicationIDs,
  handleSelectApplication
}) =>
  applications.length >= 1 &&
  applications.map((application) => (
    <ApplicationCard
      key={application.aid}
      application={application}
      selectable={true}
      selected={selectedApplicationIDs.includes(application.aid)}
      onClickHandler={handleSelectApplication}
    />
  ));

export default AllApprovedApplications;
